module.exports = __webpack_public_path__ + "img/environment3.fbf87ab7.png";